/**
 * @mixin
 */
import { kebabCase } from '../utils/util'
export default {
  mounted() {
    if (process.env.NODE_ENV === 'production') { return }
    if (!this.$vnode) { return }
    const { data, componentOptions } = this.$vnode
    const definedProps = data.attrs || {}
    const definedEvents = componentOptions.listeners || {}

    for (let propName in definedProps) {
      propName = kebabCase(propName)
    }

    for (let eventName in definedEvents) {
      eventName = kebabCase(eventName)
    }
  },
  methods: {
    getMigratingConfig() {
      return {
        props: {},
        events: {}
      }
    }
  }
}